import { Question } from './question/question.model';
import { Section } from './section.model';
import { FormPublicationStatus, FormStatus } from './status.model';

export interface FormStructure {
  description: string;
  order?: string[];
  numberedQuestions: boolean;
}

export interface Form {
  id: string;
  title: string;
  type?: FormType;
  sections?: Section[];
  structure?: FormStructure;
  changedBy?: string;
  status?: FormStatus;
  publicationStatus?: FormPublicationStatus;
  copiedFrom?: string;
  copiedBy?: string;
  copiedDate?: Date;
  isTemplate?: boolean;
  isActiveTemplate?: boolean;
  hasTemplateId?: boolean;
  templateFormName?: string;
  baseQuestions?: Question[];
  relatedForms?: FormsRelated[];
}

export interface FormsRelated {
  id: string;
  title: string;
  type?: FormType;
  status?: FormStatus;
}

export enum FormType {
  Undefined = 'Undefined',
  Application = 'Application',
  StartReport = 'StartReport',
  ProgressReport = 'ProgressReport',
  EndReport = 'EndReport',
  AfterReport = 'AfterReport',
  ComplementReport = 'ComplementReport',
  FollowUpQuestions = 'FollowUpQuestions',
  Questionnaire = 'Questionnaire',
  ChangeRequest = 'ChangeRequest',
  Skiss = 'Skiss',
  Projektbidrag = 'Projektbidrag',
  ProjektparterBudget = 'ProjektparterBudget',
}

export enum ReadonlyState {
  Editable,
  Locked,
  Reader,
}
